import SelectedMembers from './SelectedMembers.component';

export default SelectedMembers;
